var dictionary = {
    messages: {
        decimal: function (e, i) {
            void 0 === i && (i = []);
            var n = i[0];
            return void 0 === n && (n = "*"), "Polje mora biti numeričko i može sadržavati " + ("*" === n ? "" : n) + " decimalna broja."
        },
        max: function (e, i) {
            return e + " ne smije biti veći od " + i[0] + " znakova."
        },
        max_value: function (e, i) {
            return "Upišite iznos manji od " + i[0] + "."
        },
        min_value: function () {
            return "Vrijednost unosa mora biti veća od 0."
        },
        numeric: function (e) {
            return e + " može sadrživati samo numeričke znakove"
        },
        required: function (e) {
            return "Obavezan unos polja!"
        }
    },
    attributes: {}
};

export {
    dictionary
};